import type { AgentContinuityView } from "@opencloud/agent-protocol";
import { Alert, AlertDescription, AlertTitle } from "@opencloud/ui";

/**
 * Saving, restoring, and compaction are routine background work, so only a
 * conversation whose last turn stopped part-way is surfaced. The next message
 * continues it from the conversation history and the files as they are now.
 */
export function ContinuityStatus({ continuity }: {
  continuity: AgentContinuityView | undefined;
}) {
  if (continuity?.schemaVersion !== 1 || continuity.state !== "recovery_required") return null;
  return <Alert data-continuity-state="recovery_required" aria-live="polite">
    <AlertTitle>The last turn didn't finish</AlertTitle>
    <AlertDescription>
      <p>Send a message to continue. The Agent picks up from this conversation and the app's files as they are now, so it may redo part of that turn.</p>
    </AlertDescription>
  </Alert>;
}
